import { Component, Input } from '@angular/core';
import { ActionLogResult, NotificationLevel } from '@birco/rainmesh-api';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-tag',
  imports: [NgClass],
  template:
    '<p class="tag truncate" [class.small]="isSmall" [ngClass]="css"><ng-content></ng-content></p>',
  styleUrl: './tag.component.scss',
})
export class TagComponent {
  @Input() level?: NotificationLevel | ActionLogResult | string;
  @Input() size: 'small' | 'default' = 'default';

  get css() {
    switch (this.level) {
      case ActionLogResult.SUCCESSFUL:
      case NotificationLevel.INFO:
        return 'success';
      case NotificationLevel.WARN:
        return 'warn';
      case ActionLogResult.FAILED:
      case NotificationLevel.ERROR:
        return 'error';
      case 'disabled':
        return 'disabled';
      case ActionLogResult.PENDING:
      default:
        return undefined;
    }
  }

  get isSmall() {
    return this.size === 'small';
  }
}
